/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pl-delivery-info.vue?vue&type=template&id=b2f3ad4c&"
import script from "./pl-delivery-info.vue?vue&type=script&lang=js&"
export * from "./pl-delivery-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports